import React from 'react';
import { useSelector } from 'react-redux';
import { getNetworkLabel } from '../utils/network';

const TokenComponent = ({ tokenAddress }) => {
  const chainId = useSelector((state) => state.provider.chainId);
  const contracts = useSelector((state) => state.tokens.contracts);

  return (
    <div className="my-4">
      <h2>Token Information</h2>
      <p>Network: {getNetworkLabel(chainId)}</p>
      <p>Selected token: {tokenAddress || '—'}</p>
      <p>DAPP: {contracts?.dappToken1Address || '—'}</p>
      <p>USD: {contracts?.usdToken1Address || '—'}</p>
      <p>AMM1: {contracts?.amm1Address || '—'}</p>
      <p>AMM2: {contracts?.amm2Address || '—'}</p>
      <p>Aggregator: {contracts?.aggregatorAddress || '—'}</p>
    </div>
  );
};

export default TokenComponent;
